import State from 'interfaces/state/State';
import { createSelector } from 'reselect';

export const isLoading$ = (state: State) => state.invite.isLoading;
export const isError$ = (state: State) => state.invite.isError;
export const created = (state: State) => state.invite.created;
export const created$ = createSelector(created, created => created);
export const received = (state: State) => state.invite.received;
export const received$ = createSelector(received, received => received);
